import { render, staticRenderFns } from "./editorBlank.vue?vue&type=template&id=7dceac0e"
import script from "./editorBlank.vue?vue&type=script&lang=js"
export * from "./editorBlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports